export default (background: string) => `
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Coriolis" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="202-Replica-Executions" transform="translate(-392.000000, -871.000000)">
            <g id="Group-2" transform="translate(360.000000, 240.000000)">
                <g id="Group-3" transform="translate(0.000000, 79.000000)">
                    <g id="Icon/Warning" transform="translate(32.000000, 552.000000)">
                        <circle fill="${background}" fill-rule="evenodd" cx="8" cy="8" r="8"></circle>
                        <path d="M8,8 L8,4" id="Line-Copy" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"></path>
                        <path d="M8,12.5 C8.69035594,12.5 9.25,11.9403559 9.25,11.25 C9.25,10.5596441 8.69035594,10 8,10 C7.30964406,10 6.75,10.5596441 6.75,11.25 C6.75,11.9403559 7.30964406,12.5 8,12.5 Z" id="Oval-3" fill="#FFFFFF" fill-rule="evenodd"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`;
